import React from "react";
import { Button, Radio, Select, TextField } from "components";
import { useExemptionsContext } from "../../ExemptionsContext";
import ButtonV2 from "elements/ButtonV2";
import formatDate from "utils/formatDate";
import { isValidDate } from "utils/validDate";

const Portability = () => {
	const {
		flowId,
		next,
		previousAddressValue,
		specialFieldsValue,
		setSpecialFieldsValue,
		previousMoveOutDateValue,
		setPreviousMoveOutDateValue,
	} = useExemptionsContext();

	const handleSubmit = async () => {
		next();
	};

	const btnDisabled = React.useMemo(() => {
		if (specialFieldsValue?.previous_address_homestead === undefined)
			return true;
		if (
			specialFieldsValue?.previous_address_homestead === true &&
			specialFieldsValue?.previous_address_file_portability === undefined
		) {
			return true;
		}
		if (
			specialFieldsValue?.previous_address_homestead === true &&
			specialFieldsValue?.previous_address_file_portability === true &&
			previousMoveOutDateValue?.length !== 10
		) {
			return true;
		}
		return false;
	}, [specialFieldsValue]);

	return (
		<form
			onSubmit={e => {
				e.preventDefault();
				handleSubmit();
			}}>
			<div className="property-profile-question-card">
				<div className="property-profile-question-card-top">
					<div className="property-profile-question-card-title-container">
						<p>Did you have a homestead at {previousAddressValue}?</p>
						<div className="property-profile-question-card-radio">
							<Radio
								name="homesteadAtPreviousAddress"
								checked={
									specialFieldsValue?.previous_address_homestead === true
								}
								onChange={e => {
									setSpecialFieldsValue({
										previous_address_homestead: true,
									});
								}}
								value="Yes"
								label="Yes"
							/>
							<Radio
								name="homesteadAtPreviousAddress"
								checked={
									specialFieldsValue?.previous_address_homestead === false
								}
								onChange={e => {
									setSpecialFieldsValue({
										previous_address_homestead: false,
									});
								}}
								value="No"
								label="No"
							/>
						</div>
					</div>
				</div>
			</div>
			{specialFieldsValue?.previous_address_homestead === true && (
				<div className="property-profile-question-card mt-4">
					<div className="property-profile-question-card-top">
						<div className="property-profile-question-card-title-container">
							<p>
								Would you like to transfer your Save our Homes savings credit by
								filing for portability?
							</p>
							<div className="property-profile-question-card-radio">
								<Radio
									name="filePortability"
									checked={
										specialFieldsValue?.previous_address_file_portability ===
										true
									}
									onChange={e => {
										setSpecialFieldsValue({
											previous_address_file_portability: true,
										});
									}}
									value="Yes"
									label="Yes"
								/>
								<Radio
									name="filePortability"
									checked={
										specialFieldsValue?.previous_address_file_portability ===
										false
									}
									onChange={e => {
										setSpecialFieldsValue({
											previous_address_file_portability: false,
										});
									}}
									value="No"
									label="No"
								/>
							</div>
						</div>
						<p className="sm property-profile-question-card-subtitle">
							This is not a transfer of a homestead, contact your county
							appraiser to remove homestead on your previous property.
						</p>
					</div>
				</div>
			)}
			{specialFieldsValue?.previous_address_file_portability === true && (
				<div className="property-profile-question-card mt-4">
					<div className="property-profile-question-card-top">
						<div className="property-profile-question-card-title-container">
							<p>Date sold or no longer occupied</p>
						</div>
						<TextField
							required
							label="Date"
							placeholder="MM/DD/YYYY"
							containerClassName="exemptions-card-input"
							maxLength={10}
							minLength={10}
							value={previousMoveOutDateValue ?? ""}
							onChange={e => {
								const formatted = formatDate(e, previousMoveOutDateValue ?? "");
								const valid = isValidDate(formatted);
								if (valid) {
									setPreviousMoveOutDateValue(formatted);
								}
							}}
						/>
					</div>
				</div>
			)}
			<ButtonV2 size="large" disabled={btnDisabled} type="submit">
				Continue
			</ButtonV2>
		</form>
	);
};

export default Portability;
